import { Component, OnInit } from "@angular/core";
import { locale as italian } from "../../../../i18n/it";
import { UtilsService } from "../../../../auth/service/utils.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { environment } from "../../../../../environments/environment";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { ICustomer, ICustomerReferentList } from "../../customer.interface";
import { CustomerService } from "../../customer.service";

@Component({
  selector: "app-referents",
  templateUrl: "./customers-referents-list.component.html",
  styleUrls: ["./customers-referents-list.component.scss"],
})
export class CustomersReferentsListComponent implements OnInit {
  public contentHeader: IContentHeader = null;
  public formGroupEdit: FormGroup;
  public tableLimit: number = 10;
  public currentReferent: ICustomerReferentList = null;
  public customers: ICustomer[] = [];
  public referents: ICustomerReferentList[] = [];
  public filteredReference: ICustomerReferentList[] = [];
  public searchKey: string = "";
  public toggleModalAdd: boolean = false;

  constructor(
    public _utilService: UtilsService,
    public _modalService: NgbModal,
    private _formBuilder: FormBuilder,
    private customerService: CustomerService,
  ) {
    this.contentHeader = {
      headerTitle: italian.data.MENU.CUSTOMERS_REFERENCE,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: italian.data.CUSTOMERS,
            isLink: false,
          },
          {
            name: italian.data.MENU.CUSTOMERS_REFERENCE,
            isLink: false,
          },
        ],
      },
    };
  }

  async ngOnInit() {
    this.formGroupEdit = this._formBuilder.group({
      client: new FormControl("", [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      name: new FormControl("", [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      surname: new FormControl("", [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      email: new FormControl("", [Validators.required, Validators.minLength(6), Validators.maxLength(255), Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]),
      phone: new FormControl("", [Validators.required, Validators.minLength(9), Validators.maxLength(15)]),
      label: new FormControl("", [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
    });

    this.referents = await this.customerService.getReferents().then((referents: ICustomerReferentList[]) => {
      return referents.map((referent: ICustomerReferentList) => {
        if (referent.client && referent.client.logo) {
          referent.client.logo = environment.CDN_URL + "/" + referent.client.logo;
        }
        referent.address_name = referent.addresses[0].label;
        return referent;
      });
    });

    await this.search();
  }

  updateTableLimit(event: any) {
    this.tableLimit = Number(event.target.value);
  }

  openEditModal(selectedReferent: ICustomerReferentList) {
    setTimeout(() => {
      this.currentReferent = selectedReferent;
    });
  }

  async search() {
    const key: string = this.searchKey.trim().toLowerCase();
    let filteredReference: ICustomerReferentList[] = this.referents;
    if (key.length > 0) {
      filteredReference = filteredReference.filter((item: ICustomerReferentList) => {
        return item.complete_name.toLowerCase().includes(key) || item.email.toLowerCase().includes(key) || item.client.name.toLowerCase().includes(key) || item.addresses[0].label.toLowerCase().includes(key);
      });
    }
    this.filteredReference = filteredReference;
  }

  async delete(referent: ICustomerReferentList) {
    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");
    deleteText += await this._utilService.translate("ALERT.CONFIRM_DELETE_THIS_OBJECT");
    deleteText += ` ${referent.complete_name}`;
    await this._utilService
      .showSWALDeleteConfirmation({ text: deleteText })
      .then(async (result) => {
        if (result.value) {
          this._utilService.showLoading();
          await this.customerService
            .deleteReferent(referent.id)
            .then(async () => {
              this.filteredReference = this.filteredReference.filter((item) => item.id != referent.id);
              this.referents = this.referents.filter((item) => item.id != referent.id);
              this._utilService.hideLoading();
              await this._utilService.showSWALSuccess({ text: "SUCCESS_DELETE_CUSTOMER_REFERENT" });
            })
            .catch(async () => {
              this._utilService.hideLoading();
              await this._utilService.showSWALError({ text: "ERROR_DELETE_CUSTOMER_REFERENT" });
            });
        } else if (result.isDismissed) {
          this._utilService.hideLoading();
          await this._utilService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT",
          });
        }
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_DELETE_CUSTOMER_REFERENT" });
      });
  }

  showModalAdd() {
    this.toggleModalAdd = true;
  }

  async onReferentModalFormEvent() {
    this.referents = await this.customerService.getReferents().then((referents: ICustomerReferentList[]) => {
      return referents.map((referent: ICustomerReferentList) => {
        if (referent.client && referent.client.logo) {
          referent.client.logo = environment.CDN_URL + "/" + referent.client.logo;
        }
        return referent;
      });
    });

    await this.search();
  }
}
